export default {
  show() {
    return this.isSystemAdmin();
  },
  destroy(group) {
    return this.isSystemAdmin() && group && !group.system;
  },
};
